import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Facebook, Instagram, LinkedIn, TikTok, Twitter } from 'blaze-ui/icons'

interface Props {
  provider: ExternalIntegrationEnum
  size: number
}

export const ProviderIcon = ({ provider, size }: Props) => {
  switch (provider) {
    case ExternalIntegrationEnum.Facebook:
      return <Facebook size={size} />
    case ExternalIntegrationEnum.Instagram:
      return <Instagram size={size} />
    case ExternalIntegrationEnum.LinkedIn:
      return <LinkedIn size={size} />
    case ExternalIntegrationEnum.X:
      return <Twitter size={size} />
    case ExternalIntegrationEnum.TikTok:
      return <TikTok size={size} />
    default:
      return <Instagram size={size} />
  }
}
